<template>
  <div>
    <h2>Edit profile</h2>
    <b-row class="mt-4">
      <b-col cols="12" md="6">
        <b-alert
          :show="dismissCountDown"
          dismissible
          :variant="alertType"
          @dismissed="dismissCountDown=0"
        >{{ alertText }}</b-alert>

        <form action="" method="POST" class="profile-form" v-on:submit.prevent="updateProfile">
          <div class="form-group">
            <label>First name </label>
            <input
              name="first_name"
              class="form-control"
              placeholder="First name"
              type="text"
              :value="firstName"
              @change="setFirstName($event.target.value)"
            />
            <div class="invalid-feedback">
              Please provide your first name.
            </div>
          </div>
          <!-- form-group// -->

          <div class="form-group">
            <label>Last name </label>
            <input
              name="last_name"
              class="form-control"
              placeholder="Last name"
              type="text"
              :value="lastName"
              @change="setLastName($event.target.value)"
            />
            <div class="invalid-feedback">
              Please provide your surname.
            </div>
          </div>

          <div class="form-group">
            <label>Company </label>
            <input
              name="company"
              class="form-control"
              placeholder="Where you work"
              type="text"
              :value="company"
              @change="setCompany($event.target.value)"
            />
          </div>

          <div class="form-group">
            <label>Phone number </label>
            <input
              name="mobile"
              class="form-control"
              placeholder="+1(234)5678910"
              type="text"
              :value="mobile"
              @change="setMobile($event.target.value)"
            />
          </div>
          <!-- form-group// -->

          <div class="form-group" label="Work email*">
            <label>Work email *</label>
            <input
              name="email"
              class="form-control"
              placeholder="you@yourwork.com"
              type="email"
              required
              v-model="email"
              disabled
            />
            <div class="invalid-feedback">
              Please provide a valid email address.
            </div>
          </div>
          <!-- form-group// -->

          <div class="form-group">
            <button
              type="submit"
              class="btn btn-primary btn-block"
              :disabled="!isDirty"
            >
              SAVE CHANGES
            </button>
          </div>
          <!-- form-group// -->
        </form>
        </b-col>
        <b-col cols="12" md="6">
            <PasswordForm></PasswordForm>
        </b-col>
    </b-row>
    </div>
</template>

<script>
import apiClient from '@/services/api_client_crm.js'
import { mapGetters } from 'vuex'
import PasswordForm from '@/components/PasswordForm.vue'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      modified: false,
      alertType: 'warning',
      alertText: '',
      dismissCountDown: 0,
      form: {
        first_name: '',
        last_name: '',
        company: '',
        mobile: ''
      }
    }
  },
  components: {
    PasswordForm
  },
  validations: {
    form: {
      first_name: { required, minLength: minLength(1) },
      last_name: { required, minLength: minLength(1) },
      company: {},
      mobile: {}
    }
  },
  methods: {
    setFirstName (value) {
      this.$store.commit('UPDATE_USER_ATTR', ['first_name', value])
      this.$v.form.first_name.$touch()
    },
    setLastName (value) {
      this.$store.commit('UPDATE_USER_ATTR', ['last_name', value])
      this.$v.form.last_name.$touch()
    },
    setCompany (value) {
      this.$store.commit('UPDATE_USER_ATTR', ['company', value])
      this.$v.form.company.$touch()
    },
    setMobile (value) {
      this.$store.commit('UPDATE_USER_ATTR', ['mobile', value])
      this.$v.form.mobile.$touch()
    },
    updateProfile () {
      apiClient.patch('/api/profile', {
        first_name: this.firstName,
        last_name: this.lastName,
        mobile: this.mobile,
        company: this.company
      }).then((response) => {
        console.log(response)
        this.alertType = 'success'
        this.alertText = 'Profile updated'
        this.dismissCountDown = 4
        this.$store.commit('UPDATE_USER', response.data.profile)
        this.$store.commit('UPDATE_ACCOUNT', response.data.account)
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data) // => the response payload
        }
      })
    }
  },
  computed: {
    ...mapGetters([
      'firstName',
      'lastName',
      'company',
      'mobile',
      'email'
    ]),
    showAlert: {
      get () {
        return this.show_alert
      },
      set (value) {
        this.show_alert = value
      }
    },
    isDirty () {
      console.log(this.$v)
      return this.$v.form.$anyDirty
    }
  }
}
</script>

<style scoped>

.form-control::-webkit-input-placeholder {
  color: #bbb;
}

</style>
